// Global constants file
// All const should be a const and be a value that doesn't change.
// If it's a function, please use the components/helpers file
// please follow the upper case pattern. Comments always welcome.

export const MILLIONS_OF_ICONS = 10;
export const MILLIONS_OF_ASSETS = 10;

export const TEAM_MAX_SIZE = 600;
export const TEAM_MIN_SIZE = 2;

export const MONTHLY_PRICE_PLAN = 9.99;
export const TEAM_MONTHLY_PRICE_PLAN = 9.99;
export const TEAM_MIN_MONTH_PRICE = TEAM_MONTHLY_PRICE_PLAN * TEAM_MIN_SIZE;
export const ANNUAL_PRICE_AS_YEARLY = 39.99;
export const CPRO_PRICE_AS_YEARLY = 119.88;
export const EDU_PER_YEAR_COST = 19.99;
export const SINGLE_ICON_PRICE = 4.99;
export const STANDARD_PHOTO_PRICE = 10.99;
export const PREMIUM_PHOTO_PRICE = 34.99;
// comes out as 3.3325. This # is important for calcs for subscriptions that product wants
export const ANNUAL_PRICE_AS_MONTHLY = ANNUAL_PRICE_AS_YEARLY / 12;
// round CPRO_PRICE_AS_YEARLY / 12 to nearest cent & convert to fixed length
export const CPRO_PRICE_AS_MONTHLY = (
    Math.round((CPRO_PRICE_AS_YEARLY / 12) * 100) / 100
).toFixed(2);
export const TEAM_MIN_YEAR_PRICE =
    Math.round(((ANNUAL_PRICE_AS_YEARLY * TEAM_MIN_SIZE) / 12) * 100) / 100;
// extra monthly cost of the CPro add-on over the base yearly Pro plan, per user
export const CPRO_ADDON_PRICE_AS_MONTHLY =
    Math.round((Number(CPRO_PRICE_AS_MONTHLY) - ANNUAL_PRICE_AS_MONTHLY) * 100) / 100;

// Keep in sync with ImageGenModel.CREDITS_PER_VECTORIZE in noun_project/custom_sets/models.py
export const CREDITS_PER_VECTORIZE = 20;
// Keep in sync with DEFAULT_CREDITS_PER_IMAGE_GEN in noun_project/settings/base.py
export const CREDITS_PER_GENERATION = 20;
export const CREDITS_PER_GENERATION_SUBS = 18;

export const ICON_GEN_CREDIT_PACK_PRICE = 8.99;
export const ICON_GEN_PACK_SIZE = 900;
export const ICON_GENS_PER_PACK = ICON_GEN_PACK_SIZE / CREDITS_PER_GENERATION;

export const ICON_GEN_MD_SIZE = 512;
export const ICON_GEN_LG_SIZE = 1200;
export const ICON_GEN_XL_SIZE = 3600;

// API plans
export const API_PAYG_MIN_MONTHLY_PAYMENT = 25;

// international pricing experiment
export const NON_US_MONTHLY_PRICE_PLAN = 4.99;
export const NON_US_ANNUAL_PRICE_AS_YEARLY = 19.99;
export const NON_US_ANNUAL_PRICE_AS_MONTHLY = NON_US_ANNUAL_PRICE_AS_YEARLY / 12;

export const CENTS = "cents";
export const PERCENT = "percent";

export const SUBTEXT_ANNUAL_TEAM_PLAN = "/month per user paid yearly";
export const SUBTEXT_ANNUAL_TEAM_PLAN_AS_MONTHLY = "/month per user";
export const SUBTEXT_ANNUAL_PLAN_AS_MONTHLY = "/month paid yearly";
export const SUBTEXT_ANNUAL_EDU_PLAN = "/year per user";
export const SUBTEXT_MONTHLY_PLAN = "/month";

export const SHORT_SUBTEXT_ANNUAL_PLAN = "/yearly";
export const SHORT_SUBTEXT_ANNUAL_PLAN_AS_MONTHLY = "/mo paid yearly";
export const SHORT_SUBTEXT_MONTHLY_PLAN = "/mo";

export const PER_MONTH = "/month";
export const PER_YEAR = "/year";

export const YEARLY_PLAN_TYPE = "yearly";

export const YEARLY_SUBSCRIPTION_PLAN_NAME = "Noun Pro Yearly";
export const MONTHLY_SUBSCRIPTION_PLAN_NAME = "Noun Pro Monthly";
export const CPRO_SUBSCRIPTION_PLAN_NAME = "Noun Pro Yearly Plus Icon Sets & Photos";

export const ICONS = "icons";
export const ICON_SETS = "icon-collections";
export const PHOTOS = "photos";

export const BROWSE_LIST_TYPE = "browse";
export const SEARCH_LIST_TYPE = "search";
export const MATCH_LIST_TYPE = "match";

// used for load more, view more, etc
export const CONTENT_TYPE = {
    icon: "icon",
    iconSet: "icon set",
    photo: "photo",
};

export const PROD_BASE_URL = "https://thenounproject.com";

// Error Messages
export const ERROR_MESSAGES = {
    RATE_LIMIT_EXCEEDED:
        "Sorry, use exceeds system security settings. Please wait a bit and try again.",
    GENERIC_ERROR: "Sorry, something went wrong. Please try again later.",
};
